import React from 'react';
import mapboxgl from 'mapbox-gl';
import { makeStyles } from "@material-ui/core/styles";
// import PropTypes from 'prop-types';
import GridContainer from "components/Grid/GridContainer.js";

import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import CustomDropdown from "components/CustomDropdown/CustomDropdown.js";

import styles from "assets/jss/material-kit-react/views/landingPageSections/productStyle.js";
import bank_icon from 'assets/img/intro/bank.png'
import government_icon from 'assets/img/intro/government.png'
import touristicreligious_icon from 'assets/img/intro/touristicreligious.png'
import hospital_icon from 'assets/img/intro/hospital.png'
import school_icon from 'assets/img/intro/school.png'

import {district_data} from 'assets/map_data/bhaktapur_district.js'
import {district_data_bank} from 'assets/map_data/bhaktapur_district_bank.js'
import {district_data_hospital} from 'assets/map_data/bhaktapur_district_hospital.js'
import {district_data_school} from 'assets/map_data/bhaktapur_district_school.js'
import {district_data_government} from 'assets/map_data/bhaktapur_district_government.js'
import {district_data_touristic_religious} from 'assets/map_data/bhaktapur_district_touristic_religious.js'
import { municipality_data_all } from 'assets/map_data/selected_municipalities.js'
import { infrastructure } from 'assets/map_data/municipality_infrastructure.js'
import * as turf from '@turf/turf'

const selected_municipalities_data = municipality_data_all.selected_municipalities_data;
const changunarayan_municipality_data = municipality_data_all.changunarayan_municipality_data;
const bhaktapur_municipality_data = municipality_data_all.bhaktapur_municipality_data;
const madhyapur_thimi_municipality_data = municipality_data_all.madhyapur_thimi_municipality_data;
const suryabinayak_municipality_data = municipality_data_all.suryabinayak_municipality_data;

const selected_municipalities_data_map = {
  'bhaktapur': bhaktapur_municipality_data,
  'changunarayan': changunarayan_municipality_data,
  'madhyapur_thimi': madhyapur_thimi_municipality_data,
  'suryabinayak': suryabinayak_municipality_data
}

const useStyles = makeStyles(styles);

const mapConfig = {
  accessToken:
    'pk.eyJ1IjoiYXJqdW5nYXV0YW0iLCJhIjoiY2pxM3VmbG4yMGMyZjQybzU1aW9hcWY3eiJ9.KEW4wlm1BULoqV_uyahTjQ',
  mapStyle: 'mapbox://styles/mapbox/light-v9',
  minZoom: 3,
  maxZoom: 16,
  zoomLevel: 11,
  center: [85.4281287, 27.6720287],
  attribution: '',
  // fullscreenQuerySelector: '#map',
  fullscreenQuerySelector: '#fullscreen_cover',
  // fullscreenQuerySelector: '#main_page',78.277588,24.547476,90.461426,31.503960
  maxBounds: [[76.277588, 24.547476], [92.461426, 31.50396]],
};

let mapContainer = () => {}

const loadMap = (display_content, props)=> {
  // GETTING MAP READY
  mapboxgl.accessToken = mapConfig.accessToken;
  const map = new mapboxgl.Map({
    attributionControl: false,
    container: mapContainer,
    style: mapConfig.mapStyle,
    center: mapConfig.center,
    zoom: mapConfig.zoomLevel,
    maxZoom: mapConfig.maxZoom,
    minZoom: mapConfig.minZoom,
    maxBounds: mapConfig.maxBounds,
  })
    .addControl(
      new mapboxgl.AttributionControl({
        compact: true,
        customAttribution: mapConfig.attribution,
      }),
    )
    .addControl(new mapboxgl.NavigationControl(), 'top-left');

  // GETTING THE GEOJSON READY
  // const geojson = {
  //   type: 'FeatureCollection',
  //   features: [],
  // };

  // LOADING THE MAP
  map.on('load', () => {
    // LOADING GEOJSON DATA
    if (props.selectedMunicipality !== undefined) {

      map.addSource('boundary_numicipalities', {
        type: 'geojson',
        data: selected_municipalities_data,
      });
      map.addLayer({
        'id': 'boundary_numicipalities',
        'type': 'line',
        'source': 'boundary_numicipalities',
        'layout': {},
        'paint': {
          'line-color': '#134c7a',
          'line-width': 2,
        },
      });

      map.addSource('municipality_fill', {
        type: 'geojson',
        data: selected_municipalities_data_map[props.selectedMunicipality],
      });
      map.addLayer({
        'id': 'municipality_fill',
        'type': 'fill',
        'source': 'municipality_fill',
        'layout': {},
        'paint': {
          'fill-color': 'blue',
          'fill-opacity': 0.2,
        },
      });

      map.addSource('map_data', {
        type: 'geojson',
        data: display_content,
        cluster: true,
        clusterMaxZoom: 14, // Max zoom to cluster points on
        clusterRadius: 50 // Radius of each cluster when clustering points (defaults to 50)
      });
      map.addLayer({
        id: 'clusters',
        type: 'circle',
        source: 'map_data',
        filter: ['has', 'point_count'],
        marker: 'pointer',
        paint: {
          'circle-color': ['step', ['get', 'point_count'], '#51bbd6', 100, '#f1f075', 750, '#f28cb1'],
          'circle-radius': [ 'step', ['get', 'point_count'], 20, 100, 30, 750, 40]
        }
        });

      map.addLayer({
        id: 'cluster-count',
        type: 'symbol',
        source: 'map_data',
        filter: ['has', 'point_count'],
        layout: {
          'text-field': '{point_count_abbreviated}',
          'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
          'text-size': 12,
        }
      });

        map.addLayer({
        id: 'unclustered-point',
        type: 'symbol',
        source: 'map_data',
        filter: ['!', ['has', 'point_count']],
        marker: 'pointer',

        "layout": {
            "icon-image": "marker-15",
            "icon-size": 1.5,
        }}
        );

        map.on('click', 'clusters', function(e) {
          var features = map.queryRenderedFeatures(e.point, {
          layers: ['clusters']
          });
          var clusterId = features[0].properties.cluster_id;
          map.getSource('map_data').getClusterExpansionZoom(
          clusterId,
          function(err, zoom) {
            if (err) return;
            map.easeTo({
              center: features[0].geometry.coordinates,
              zoom: zoom
            });
          }
          );
        });

        let _popup = new mapboxgl.Popup()

        map.on('mouseenter', 'unclustered-point', function(e) {
          var coordinates = e.features[0].geometry.coordinates.slice();
          var name = e.features[0].properties.name;
          if (name === undefined) {
            name = e.features[0].properties['name:en'];
          }
          while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
          coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
          }
          _popup
          .setLngLat(coordinates)
          .setHTML(
          'नाम: ' + name
          )
          .addTo(map);
        });
        map.on('mouseenter', 'unclustered-point', function(e) {
          map.getCanvas().style.cursor = 'pointer';
        });
        map.on('mouseleave', 'unclustered-point', function(e) {
          map.getCanvas().style.cursor = '';
          _popup.remove();

        });

        map.on('mouseenter', 'clusters', function() {
          map.getCanvas().style.cursor = 'pointer';
        });
        map.on('mouseleave', 'clusters', function() {
          map.getCanvas().style.cursor = '';
        });

        var bounds = turf.bbox(selected_municipalities_data_map[props.selectedMunicipality]);
        map.fitBounds(bounds, {padding: 20});
    }

    else {
      map.addSource('area_fill', {
        type: 'geojson',
        data: district_data,
      });
      map.addSource('area_fill_changunarayan', {
        type: 'geojson',
        data: municipality_data_all.changunarayan_municipality_data,
      });
      map.addSource('area_fill_bhaktapur', {
        type: 'geojson',
        data: municipality_data_all.bhaktapur_municipality_data,
      });
      map.addSource('area_fill_madhyapur_thimi', {
        type: 'geojson',
        data: municipality_data_all.madhyapur_thimi_municipality_data,
      });
      map.addSource('area_fill_suryabinayak', {
        type: 'geojson',
        data: municipality_data_all.suryabinayak_municipality_data,
      });
      // map.addSource('area_fill', {
      //   type: 'geojson',
      //   data: district_data,
      // });
      map.addSource('area_boundaries_changunarayan', {
        type: 'geojson',
        data: municipality_data_all.changunarayan_municipality_data,
      });
      map.addSource('area_boundaries_bhaktapur', {
        type: 'geojson',
        data: municipality_data_all.bhaktapur_municipality_data,
      });
      map.addSource('area_boundaries_madhyapur_thimi', {
        type: 'geojson',
        data: municipality_data_all.madhyapur_thimi_municipality_data,
      });
      map.addSource('area_boundaries_suryabinayak', {
        type: 'geojson',
        data: municipality_data_all.suryabinayak_municipality_data,
      });
      // map.addLayer({
      //   'id': 'area_boundaries',
      //   'type': 'fill',
      //   'source': 'area_boundaries',
      //   'layout': {},
      //   'paint': {
      //     'fill-color': '#678',
      //     'fill-opacity': 0.1,
      //   },
      // });
      map.addLayer({
        'id': 'area_fill_changunarayan',
        'type': 'fill',
        'source': 'area_fill_changunarayan',
        'layout': {},
        'paint': {
          'fill-color': 'green',
          'fill-opacity': 0.2,
        },
      });
      map.addLayer({
        'id': 'area_fill_bhaktapur',
        'type': 'fill',
        'source': 'area_fill_bhaktapur',
        'layout': {},
        'paint': {
          'fill-color': 'yellow',
          'fill-opacity': 0.2,
        },
      });
      map.addLayer({
        'id': 'area_fill_madhyapur_thimi',
        'type': 'fill',
        'source': 'area_fill_madhyapur_thimi',
        'layout': {},
        'paint': {
          'fill-color': 'blue',
          'fill-opacity': 0.2,
        },
      });
      map.addLayer({
        'id': 'area_fill_suryabinayak',
        'type': 'fill',
        'source': 'area_fill_suryabinayak',
        'layout': {},
        'paint': {
          'fill-color': 'red',
          'fill-opacity': 0.2,
        },
      });

      map.addLayer({
        'id': 'area_boundaries_changunarayan',
        'type': 'line',
        'source': 'area_boundaries_changunarayan',
        'layout': {},
        'paint': {
          'line-color': '#134c7a',
          'line-width': 1,
        },
      });
      map.addLayer({
        'id': 'area_boundaries_bhaktapur',
        'type': 'line',
        'source': 'area_boundaries_bhaktapur',
        'layout': {},
        'paint': {
          'line-color': '#134c7a',
          'line-width': 1,
        },
      });
      map.addLayer({
        'id': 'area_boundaries_madhyapur_thimi',
        'type': 'line',
        'source': 'area_boundaries_madhyapur_thimi',
        'layout': {},
        'paint': {
          'line-color': '#134c7a',
          'line-width': 1,
        },
      });
      map.addLayer({
        'id': 'area_boundaries_suryabinayak',
        'type': 'line',
        'source': 'area_boundaries_suryabinayak',
        'layout': {},
        'paint': {
          'line-color': '#134c7a',
          'line-width': 1,
        },
      });
      // map.addLayer({
      //   'id': 'area_fill_changunarayan',
      //   'type': 'line',
      //   'source': 'area_fill_changunarayan',
      //   'layout': {},
      //   'paint': {
      //     'line-color': '#134c7a',
      //     'line-width': 2,
      //   },
      // });
      // map.addLayer({
      //   'id': 'area_fill_bhaktapur',
      //   'type': 'line',
      //   'source': 'area_fill_bhaktapur',
      //   'layout': {},
      //   'paint': {
      //     'line-color': '#134c7a',
      //     'line-width': 2,
      //   },
      // });
      // map.addLayer({
      //   'id': 'area_fill_madhyapur_thimi',
      //   'type': 'line',
      //   'source': 'area_fill_madhyapur_thimi',
      //   'layout': {},
      //   'paint': {
      //     'line-color': '#134c7a',
      //     'line-width': 2,
      //   },
      // });
      // map.addLayer({
      //   'id': 'area_fill_suryabinayak',
      //   'type': 'line',
      //   'source': 'area_fill_suryabinayak',
      //   'layout': {},
      //   'paint': {
      //     'line-color': '#134c7a',
      //     'line-width': 2,
      //   },
      // });

      map.addSource('map_data', {
        type: 'geojson',
        data: display_content,
        cluster: true,
        clusterMaxZoom: 14, // Max zoom to cluster points on
        clusterRadius: 50 // Radius of each cluster when clustering points (defaults to 50)
      });
      map.addLayer({
        id: 'clusters',
        type: 'circle',
        source: 'map_data',
        filter: ['has', 'point_count'],
        paint: {
          'circle-color': ['step', ['get', 'point_count'], '#51bbd6', 100, '#f1f075', 750, '#f28cb1'],
          'circle-radius': [ 'step', ['get', 'point_count'], 20, 100, 30, 750, 40]
        }
        });

      map.addLayer({
        id: 'cluster-count',
        type: 'symbol',
        source: 'map_data',
        filter: ['has', 'point_count'],
        layout: {
          'text-field': '{point_count_abbreviated}',
          'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
          'text-size': 12
        }
      });

        map.addLayer({
        id: 'unclustered-point',
        type: 'symbol',
        source: 'map_data',
        filter: ['!', ['has', 'point_count']],
        "layout": {
            "icon-image": "marker-15",
            "icon-size": 1.5,
        }}
        );

        map.on('click', 'clusters', function(e) {
          var features = map.queryRenderedFeatures(e.point, {
          layers: ['clusters']
          });
          var clusterId = features[0].properties.cluster_id;
          map.getSource('map_data').getClusterExpansionZoom(
          clusterId,
          function(err, zoom) {
            if (err) return;
            map.easeTo({
              center: features[0].geometry.coordinates,
              zoom: zoom
            });
          }
          );
        });
        let _popup = new mapboxgl.Popup()


        map.on('mouseenter', 'unclustered-point', function(e) {
          var coordinates = e.features[0].geometry.coordinates.slice();
          var name = e.features[0].properties.name;
          if (name === undefined) {
            name = e.features[0].properties['name:en'];
          }
          while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
          coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
          }
          _popup
          .setLngLat(coordinates)
          .setHTML(
          'नाम: ' + name
          )
          .addTo(map);
        });

        map.on('mouseenter', 'clusters', function() {
          map.getCanvas().style.cursor = 'pointer';
        });
        map.on('mouseleave', 'clusters', function() {
          map.getCanvas().style.cursor = '';
        });
        map.on('mouseenter', 'unclustered-point', function(e) {
          map.getCanvas().style.cursor = 'pointer';
        });
        map.on('mouseleave', 'unclustered-point', function(e) {
          map.getCanvas().style.cursor = '';
          _popup.remove();
        });
    }

  });

  // DISABLE ZOOM ON SCROLL
  map.scrollZoom.disable();
  // this.map = map;
};

export default function ProductSection(props) {
  const classes = useStyles();

  const [display_content, setDisplayContent] = React.useState(undefined);
  const [selected_amenity, setAmenity] = React.useState('school');
  const [map_active, setMapActive] = React.useState(false);

  if (display_content === undefined) {
    if (props.selectedMunicipality !== undefined) {
      setDisplayContent(infrastructure[props.selectedMunicipality][selected_amenity]);
    } else {
      setDisplayContent(district_data_school);
    }
  }

  const count_info = {
    ddc: {name: 'जि स स भक्तपुर', bank:' ५३',hospital:'६',school:'२५', government:'४३', touristic_religious: '२०३'},
    bhaktapur: {name: 'भक्तपुर नगरपालिका', bank:'६',hospital:'३',school:'६', government:'१४', touristic_religious: '५१'},
    changunarayan: {name: 'चाँगुनारायण नगरपालिका', bank:'१',hospital:'०',school:'१०', government:'२', touristic_religious: '६३'},
    madhyapur_thimi: {name: 'मध्यपुर थिमि नगरपालिका', bank:'३०',hospital:'३',school:'७', government:'२३', touristic_religious: '६९'},
    suryabinayak: {name: 'सूर्यविनायक नगरपालिका', bank:'५',hospital:'०',school:'२', government:'४', touristic_religious: '२०'},
  }
  const amenity_map = {
    'bank': 'बैंक',
    'school': 'विद्यालय',
    'hospital': 'अस्पताल',
    'government': 'सरकारी कार्यालय',
    'touristic_religious': 'धार्मिक/पर्यटन',
  }

  const clickedButton = (amenity, selectedMunicipality) => {
      if (selectedMunicipality !== undefined) {
        setDisplayContent(infrastructure[selectedMunicipality][amenity]);
        loadMap(infrastructure[selectedMunicipality][amenity], props);
        if (amenity === 'bank') {
          setAmenity('bank');
        } else if (amenity === 'hospital') {
          setAmenity('hospital');
        } else if (amenity === 'school') {
          setAmenity('school');
        } else if (amenity === 'government') {
          setAmenity('government');
        } else if (amenity === 'touristic_religious') {
          setAmenity('touristic_religious');
        }
      } else {
        if (amenity === 'bank') {
          setDisplayContent(district_data_bank);
          setAmenity('bank');
          loadMap(district_data_bank, props);
        } else if (amenity === 'hospital') {
          setDisplayContent(district_data_hospital);
          setAmenity('hospital');
          loadMap(district_data_hospital, props);
        } else if (amenity === 'school') {
          setDisplayContent(district_data_school);
          setAmenity('school');
          loadMap(district_data_school, props);
        } else if (amenity === 'government') {
          setDisplayContent(district_data_government);
          setAmenity('government');
          loadMap(district_data_government, props);
        } else if (amenity === 'touristic_religious') {
          setDisplayContent(district_data_touristic_religious);
          setAmenity('touristic_religious');
          loadMap(district_data_touristic_religious, props);
        }
      }
  }

    React.useEffect(() => {
      setMapActive(true)
      if (map_active === false) {
        loadMap(display_content, props);
      }
    }, [map_active, display_content, props]);

  return (
    <div className={classes.section}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div className={classes.description} style={{ backgroundColor: '#678', color: 'white'}}>
            <GridContainer justify="center">
              <div>
                <h3>नक्शा: {props.selectedMunicipality !== undefined ? count_info[props.selectedMunicipality]['name'] : count_info['ddc']['name']}मा रहेका {amenity_map[selected_amenity]}हरु</h3>
                <GridContainer justify="center">
                  <span>
                    <h4>अन्य जानकारीको लागि छनोट गर्नुहोस:</h4>
                  </span>
                  <span>
                        <CustomDropdown
                          noLiPadding
                          buttonText=<h4>{amenity_map[selected_amenity]}</h4>
                          buttonProps={{
                            className: classes.navLink,
                            style: { padding: 0, margin: 0, marginLeft: '5px', backgroundColor: '#456', paddingLeft: '5px', paddingRight: '5px'}
                          }}
                          dropdownList={[
                            <Button color="transparent" fullWidth onClick={()=>clickedButton('bank', props.selectedMunicipality)}>
                               बैंक
                            </Button>,
                            <Button color="transparent" fullWidth onClick={()=>clickedButton('hospital', props.selectedMunicipality)}>
                              अस्पताल
                            </Button>,
                            <Button color="transparent" fullWidth onClick={()=>clickedButton('school', props.selectedMunicipality)}>
                              विद्यालय
                            </Button>,
                            <Button color="transparent" fullWidth onClick={()=>clickedButton('government', props.selectedMunicipality)}>
                              सरकारी कार्यालय
                            </Button>,
                            <Button color="transparent" fullWidth onClick={()=>clickedButton('touristic_religious', props.selectedMunicipality)}>
                              धार्मिक/पर्यटन
                            </Button>
                          ]}
                        />
                  </span>
                </GridContainer>
              </div>
            </GridContainer>
            <div
              id="map"
              ref={el => mapContainer = el} //eslint-disable-line
              style={{ minHeight: '450px', maxHeight: '480px', height: '40vh', color: '#333' }}
            />
            <div style={{ padding: '20px' }}>
                <h3><u>कुल संख्या (नक्शामा रहेका मात्र)</u></h3>
                <GridContainer>
                  <div style={{ width: '20%', marginTop: '-30px' }}>
                    <Button color="transparent" fullWidth onClick={()=>clickedButton('bank', props.selectedMunicipality)}>
                      <div>
                        <img src={bank_icon} width="60px" alt="bank"/>
                        <h4>
                          <h3 style={{marginTop: '-15px'}}>{props.selectedMunicipality !== undefined ? count_info[props.selectedMunicipality]['bank'] : count_info['ddc']['bank']}</h3>
                          <div style={{marginTop: '-15px'}}>{'बैंक'}</div>
                        </h4>
                      </div>
                    </Button>
                  </div>
                  <div style={{ width: '20%', marginTop: '-30px' }}>
                    <Button color="transparent" fullWidth onClick={()=>clickedButton('hospital', props.selectedMunicipality)}>
                      <div>
                        <img src={hospital_icon} width="60px" alt="hospital"/>
                        <h4>
                          <h3 style={{marginTop: '-15px'}}>{props.selectedMunicipality !== undefined ? count_info[props.selectedMunicipality]['hospital'] : count_info['ddc']['hospital']}</h3>
                          <div style={{marginTop: '-15px'}}>{'अस्पताल'}</div>
                        </h4>
                      </div>
                    </Button>
                  </div>
                  <div style={{ width: '20%', marginTop: '-30px' }}>
                    <Button color="transparent" fullWidth onClick={()=>clickedButton('school', props.selectedMunicipality)}>
                      <div>
                        <img src={school_icon} width="60px" alt="school"/>
                        <h4>
                          <h3 style={{marginTop: '-15px'}}>{props.selectedMunicipality !== undefined ? count_info[props.selectedMunicipality]['school'] : count_info['ddc']['school']}</h3>
                          <div style={{marginTop: '-15px'}}>{'विद्यालय'}</div>
                        </h4>
                      </div>
                    </Button>
                  </div>
                  <div style={{ width: '20%', marginTop: '-30px' }}>
                    <Button color="transparent" fullWidth onClick={()=>clickedButton('government', props.selectedMunicipality)}>
                      <div>
                        <img src={government_icon} width="60px" alt="government"/>
                        <h4>
                          <h3 style={{marginTop: '-15px'}}>{props.selectedMunicipality !== undefined ? count_info[props.selectedMunicipality]['government'] : count_info['ddc']['government']}</h3>
                          <div style={{marginTop: '-15px'}}>{'सरकारी कार्यालय'}</div>
                        </h4>
                      </div>
                    </Button>
                  </div>
                  <div style={{ width: '20%', marginTop: '-30px' }}>
                    <Button color="transparent" fullWidth onClick={()=>clickedButton('touristic_religious', props.selectedMunicipality)}>
                      <div>
                        <img src={touristicreligious_icon} width="60px" alt="government"/>
                        <h4>
                          <h3 style={{marginTop: '-15px'}}>{props.selectedMunicipality !== undefined ? count_info[props.selectedMunicipality]['touristic_religious'] : count_info['ddc']['touristic_religious']}</h3>
                          <div style={{marginTop: '-15px'}}>{'धार्मिक/पर्यटन'}</div>
                        </h4>
                      </div>
                    </Button>
                  </div>
                </GridContainer>
            </div>
          </div>
        </GridItem>
      </GridContainer>
    </div>
  );
}
